import { useState, useEffect } from "react";
import axios from "axios";

const useCookieValidation = () => {
  const [showCookieDialog, setShowCookieDialog] = useState(false);
  const [isValidating, setIsValidating] = useState(true); // Start as true (showing loader)
  const [cookiesExpired, setCookiesExpired] = useState(true); // Start as true (disabled by default)
  const [showBanner, setShowBanner] = useState(false); // Banner only shows after API confirms expired

  const validateCookies = async () => {
    setIsValidating(true);
    try {
      const userId = String(localStorage.getItem("userId") || "123");
      const response = await axios.get(
        `http://20.127.236.209:8000/is-cookie-valid?user_id=${userId}`
      );

      // Check if cookies are expired
      if (response.data.expired === true) {
        setCookiesExpired(true);
        setShowBanner(true);
        setShowCookieDialog(true);
        return false;
      } else {
        setCookiesExpired(false);
        setShowBanner(false);
        return true;
      }
    } catch (error) {
      console.error("Error validating cookies:", error);
      // If there's an error, assume cookies might be expired and show dialog
      if (error.response?.data?.expired === true) {
        setCookiesExpired(true);
        setShowBanner(true);
        setShowCookieDialog(true);
        return false;
      }
      setCookiesExpired(false);
      setShowBanner(false);
      return true; // Don't block the app if validation fails
    } finally {
      setIsValidating(false);
    }
  };

  const closeCookieDialog = () => {
    setShowCookieDialog(false);
  };

  // Auto-validate cookies when hook is used
  useEffect(() => {
    validateCookies();
  }, []);

  return {
    showCookieDialog,
    closeCookieDialog,
    validateCookies,
    isValidating,
    cookiesExpired,
    showBanner,
  };
};

export default useCookieValidation;
